import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoProjectsGetReq } from "./abst/DtoProjectsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoProjectsGetReqImple extends DtoProjectsGetReq {
  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
